import { useParams } from 'react-router-dom'

import { SiteRouteParams } from '..'

export function useSiteParameter() {
  const {site} = useParams<SiteRouteParams>();

  return site;
}
